import { Type } from '@angular/core';
/**
 * @TODO:
 * We might be able to refactor this out due to the Standalone component refactor.
 */

/**
 * Writing the bundles using dynamic import with path and loadChildren properties we trick webpack
 * to think these are going to be use as a router configuration and it will create js bundles for each of them.
 */
export const lazyBundles: { path: string; loadChildren: () => Promise<Type<any>> }[] = [
    {
        path: 'finder-detail',
        loadChildren: () => import('../../../features/detail/detail.component').then(m => m.DetailComponent) // standalone
    },
    {
        path: 'finder-campaign',
        loadChildren: () => import('../../../features/campaign/campaign.component').then(m => m.CampaignComponent) // standalone
    },
    {
        path: 'finder-list',
        loadChildren: () => import('../../../features/list/list.component').then(m => m.ListComponent) // standalone
    },
    {
        path: 'finder-search',
        loadChildren: () => import('../../../features/search/search.component').then(m => m.SearchComponent) // standalone
    },
    {
        path: 'finder-calendar',
        loadChildren: () => import('../../../features/calendars/calendars.component').then(m => m.CalendarsComponent) // standalone
    },
    {
        path: 'debug-panel',
        loadChildren: () => import('../../components/debug-panel/debug-panel.component').then(m => m.DebugPanelComponent) // standalone
    },
    {
        path: 'discounts-modal',
        // If we break this line webpack doesn't want to create the bundle
        // so I had to disable max-length rule here
        // eslint-disable-next-line max-len
        loadChildren: () => import('../../components/discounts-modal/discounts-modal.component').then(m => m.DiscountsModalComponent) // standalone
    },
];

export const lazyArrayToObj = () =>
    lazyBundles.reduce((result: any, bundle: any) => {
        result[bundle.path] = bundle.loadChildren;

        return result;
    }, {});
